import useFormattedDate from "@/dates/use-formatted-date";
import { PropsWithChildren, ReactNode } from "react";

type ActivityItemHeaderProps = {
  title: string;
  timestamp: number;
  description?: ReactNode;
};

export function ActivityItemHeader({
  title,
  children,
  description,
  timestamp,
}: PropsWithChildren<ActivityItemHeaderProps>) {
  const { humanDate } = useFormattedDate(timestamp);
  return (
    <div>
      <div className="flex items-start gap-1 flex-1 group-hover:cursor-pointer">
        <span className="text-xs font-medium flex items-center gap-1 group-hover:underline">
          {title} {children}
        </span>
        <span className="text-xs">•</span>
        <span className="text-xs text-muted-foreground/80 font-medium">
          {humanDate}
        </span>
      </div>
      {description && description}
    </div>
  );
}
